module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"votes-remaining-wrapper\"> <span class=\"votes-remaining cat-<%= id %>\"><%= votesRemaining %></span> / <span class=\"vote-limit\"><%= voteLimit %></span> votes remaining </div> <button <%= isSubmitDisabled? 'disabled': '' %> class=\"btn-submit\">Submit Votes</button> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="votes-remaining-wrapper"> <span class="votes-remaining cat-', escape((__stack.lineno=1,  id )), '">', escape((__stack.lineno=1,  votesRemaining )), '</span> / <span class="vote-limit">', escape((__stack.lineno=1,  voteLimit )), '</span> votes remaining </div> <button ', escape((__stack.lineno=1,  isSubmitDisabled? 'disabled': '' )), ' class="btn-submit">Submit Votes</button> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/category-submit.ejs
// module id = 230
// module chunks = 0